import React from "react";
import {
  getFieldError,
  getSelectedItems,
  isFormikErrorsArray,
} from "../../_helpers/helper";
import CONTACT from "../../assets/images/contact.png";
import { FieldArray, FormikProps } from "formik";
import { useAppSelector } from "../../app/hooks";
import { IInfant, IReviewBookingDetails } from "./reviewbookingModel";
import { INITIALS } from "../../_constants/constant";
import moment from "moment";

interface InfantFormProps {
  formik: FormikProps<IReviewBookingDetails>;
  isPIDRequired: Boolean;
  isPPEDRequired: Boolean;
  isPNRequired: Boolean;
  isIDOBRRequired: Boolean;
  handleCheckboxChange: (
    type: "adults" | "children" | "infants",
    flightDetailsKey: "ADULT" | "CHILD" | "INFANT",
    index: number,
    e: React.ChangeEvent<HTMLInputElement>
  ) => void;
}

const InfantForm = ({
  formik,
  handleCheckboxChange,
  isPIDRequired,
  isPPEDRequired,
  isPNRequired,
  isIDOBRRequired,
}: InfantFormProps) => {
  const flightReviewDetails = useAppSelector(
    (state) => state.reviewbooking.flightReviewDetails
  );

  const reviewBookingDetails = useAppSelector(
    (state) => state.reviewbooking.reviewBookingDetails
  );

  const CountryList = useAppSelector((state) => state.country.CountryList);

  const paxDetails = flightReviewDetails?.searchQuery?.paxInfo;

  const INFANT = paxDetails?.INFANT || 0;

  return (
    <div className="adult-form">
      <div className="traveller-details-title">
        <p className="m-0">
          <img src={CONTACT} /> INFANT (15 Days - 2 Yrs)
          <span className="m-0 tarveller-error-message">
            {formik.errors?.infantsLimit}
          </span>
        </p>
        <strong>
          {getSelectedItems(formik.values?.infants)?.length}/{INFANT} added
        </strong>
      </div>
      <span className="note">
        <strong>Important:</strong> Enter name as mentioned on your passport or
        Government approved IDs..
      </span>
      <FieldArray name="infants">
        {({ push, remove }) => (
          <>
            {formik.values.infants.map((infant, index) => (
              <div className="child-form" key={index}>
                <div>
                  <input
                    className="form-check"
                    type="checkbox"
                    name={`infants[${index}].isSelected`}
                    checked={formik.values.infants[index].isSelected}
                    onChange={(e) =>
                      handleCheckboxChange("infants", "INFANT", index, e)
                    }
                  />
                  <h5>
                    {reviewBookingDetails?.infants[index]?.first_name
                      ? `${formik.values.infants[index]?.first_name} ${formik.values.infants[index]?.last_name}`
                      : `Infant ${
                          index -
                          (getSelectedItems(
                            reviewBookingDetails?.infants,
                            "first_name"
                          )?.length -
                            1)
                        }`}
                  </h5>
                </div>
                {formik.values.infants[index].isSelected && (
                  <div className="form">
                    <div className="field-set align-end">
                      <div className="fields">
                        <label
                          className={
                            isFormikErrorsArray<IInfant>(
                              formik.errors.infants
                            ) &&
                            isFormikErrorsArray<IInfant>(
                              formik.touched.infants
                            ) &&
                            formik.touched.infants[index]?.initial &&
                            getFieldError<IInfant>(
                              formik.errors.infants,
                              index,
                              "initial"
                            )
                              ? "error-label"
                              : ""
                          }
                        >
                          Initial <code>*</code>
                        </label>
                        <select
                          name={`infants[${index}].initial`}
                          value={formik.values.infants[index].initial}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          className={
                            isFormikErrorsArray<IInfant>(
                              formik.errors.infants
                            ) &&
                            isFormikErrorsArray<IInfant>(
                              formik.touched.infants
                            ) &&
                            formik.touched.infants[index]?.initial &&
                            getFieldError<IInfant>(
                              formik.errors.infants,
                              index,
                              "initial"
                            )
                              ? "error-border py-0"
                              : "py-0"
                          }
                        >
                          <option value="" hidden selected>
                            Select Initial
                          </option>
                          {INITIALS?.map((e: string) => (
                            <option value={e}>{e}</option>
                          ))}
                        </select>
                        {isFormikErrorsArray<IInfant>(formik.errors.infants) &&
                          isFormikErrorsArray<IInfant>(
                            formik.touched.infants
                          ) &&
                          formik.touched.infants[index]?.initial &&
                          getFieldError<IInfant>(
                            formik.errors.infants,
                            index,
                            "initial"
                          ) && (
                            <div className="error-label">
                              {getFieldError<IInfant>(
                                formik.errors.infants,
                                index,
                                "initial"
                              )}
                            </div>
                          )}
                      </div>
                      <div className="fields">
                        <label
                          className={
                            isFormikErrorsArray<IInfant>(
                              formik.errors.infants
                            ) &&
                            isFormikErrorsArray<IInfant>(
                              formik.touched.infants
                            ) &&
                            formik.touched.infants[index]?.first_name &&
                            getFieldError<IInfant>(
                              formik.errors.infants,
                              index,
                              "first_name"
                            )
                              ? "error-label"
                              : ""
                          }
                        >
                          First Name <code>*</code>
                        </label>
                        <input
                          type="text"
                          name={`infants[${index}].first_name`}
                          onChange={formik.handleChange}
                          value={formik.values.infants[index].first_name}
                          className={
                            isFormikErrorsArray<IInfant>(
                              formik.errors.infants
                            ) &&
                            isFormikErrorsArray<IInfant>(
                              formik.touched.infants
                            ) &&
                            formik.touched.infants[index]?.first_name &&
                            getFieldError<IInfant>(
                              formik.errors.infants,
                              index,
                              "first_name"
                            )
                              ? "error-border"
                              : ""
                          }
                        />
                        {isFormikErrorsArray<IInfant>(formik.errors.infants) &&
                          isFormikErrorsArray<IInfant>(
                            formik.touched.infants
                          ) &&
                          formik.touched.infants[index]?.first_name &&
                          getFieldError<IInfant>(
                            formik.errors.infants,
                            index,
                            "first_name"
                          ) && (
                            <div className="error-label">
                              {getFieldError<IInfant>(
                                formik.errors.infants,
                                index,
                                "first_name"
                              )}
                            </div>
                          )}
                      </div>
                      <div className="fields">
                        <label
                          className={
                            isFormikErrorsArray<IInfant>(
                              formik.errors.infants
                            ) &&
                            isFormikErrorsArray<IInfant>(
                              formik.touched.infants
                            ) &&
                            formik.touched.infants[index]?.last_name &&
                            getFieldError<IInfant>(
                              formik.errors.infants,
                              index,
                              "last_name"
                            )
                              ? "error-label"
                              : ""
                          }
                        >
                          Last Name <code>*</code>
                        </label>
                        <input
                          type="text"
                          className={
                            isFormikErrorsArray<IInfant>(
                              formik.errors.infants
                            ) &&
                            isFormikErrorsArray<IInfant>(
                              formik.touched.infants
                            ) &&
                            formik.touched.infants[index]?.last_name &&
                            getFieldError<IInfant>(
                              formik.errors.infants,
                              index,
                              "last_name"
                            )
                              ? "error-border"
                              : ""
                          }
                          name={`infants[${index}].last_name`}
                          onChange={formik.handleChange}
                          value={formik.values.infants[index].last_name}
                        />
                        {isFormikErrorsArray<IInfant>(formik.errors.infants) &&
                          isFormikErrorsArray<IInfant>(
                            formik.touched.infants
                          ) &&
                          formik.touched.infants[index]?.last_name &&
                          getFieldError<IInfant>(
                            formik.errors.infants,
                            index,
                            "last_name"
                          ) && (
                            <div className="error-label">
                              {getFieldError<IInfant>(
                                formik.errors.infants,
                                index,
                                "last_name"
                              )}
                            </div>
                          )}
                      </div>
                    </div>
                    <div className="field-set">
                      <div className="fields">
                        <label
                          className={
                            isFormikErrorsArray<IInfant>(
                              formik.errors.infants
                            ) &&
                            isFormikErrorsArray<IInfant>(
                              formik.touched.infants
                            ) &&
                            formik.touched.infants[index]?.date_of_birth &&
                            getFieldError<IInfant>(
                              formik.errors.infants,
                              index,
                              "date_of_birth"
                            )
                              ? "error-label"
                              : ""
                          }
                        >
                          Date of Birth {isIDOBRRequired && <code>*</code>}
                        </label>
                        <input
                          type="date"
                          name={`infants[${index}].date_of_birth`}
                          max={moment().format("YYYY-MM-DD")}
                          min={moment()
                            .subtract(2, "years")
                            .format("YYYY-MM-DD")}
                          onChange={formik.handleChange}
                          value={formik.values.infants[index].date_of_birth}
                          className={
                            isFormikErrorsArray<IInfant>(
                              formik.errors.infants
                            ) &&
                            isFormikErrorsArray<IInfant>(
                              formik.touched.infants
                            ) &&
                            formik.touched.infants[index]?.date_of_birth &&
                            getFieldError<IInfant>(
                              formik.errors.infants,
                              index,
                              "date_of_birth"
                            )
                              ? "error-border"
                              : ""
                          }
                        />
                        {isFormikErrorsArray<IInfant>(formik.errors.infants) &&
                          isFormikErrorsArray<IInfant>(
                            formik.touched.infants
                          ) &&
                          formik.touched.infants[index]?.date_of_birth &&
                          getFieldError<IInfant>(
                            formik.errors.infants,
                            index,
                            "date_of_birth"
                          ) && (
                            <div className="error-label">
                              {getFieldError<IInfant>(
                                formik.errors.infants,
                                index,
                                "date_of_birth"
                              )}
                            </div>
                          )}
                      </div>
                      {isPNRequired ? (
                        <div className="fields">
                          <label
                            className={
                              isFormikErrorsArray<IInfant>(
                                formik.errors.infants
                              ) &&
                              isFormikErrorsArray<IInfant>(
                                formik.touched.infants
                              ) &&
                              formik.touched.infants[index]?.passport_no &&
                              getFieldError<IInfant>(
                                formik.errors.infants,
                                index,
                                "passport_no"
                              )
                                ? "error-label"
                                : ""
                            }
                          >
                            Passport No {isPNRequired && <code>*</code>}
                          </label>
                          <input
                            type="text"
                            name={`infants[${index}].passport_no`}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.infants[index].passport_no}
                            className={
                              isFormikErrorsArray<IInfant>(
                                formik.errors.infants
                              ) &&
                              isFormikErrorsArray<IInfant>(
                                formik.touched.infants
                              ) &&
                              formik.touched.infants[index]?.passport_no &&
                              getFieldError<IInfant>(
                                formik.errors.infants,
                                index,
                                "passport_no"
                              )
                                ? "error-border"
                                : ""
                            }
                          />
                          {isFormikErrorsArray<IInfant>(
                            formik.errors.infants
                          ) &&
                            isFormikErrorsArray<IInfant>(
                              formik.touched.infants
                            ) &&
                            formik.touched.infants[index]?.passport_no &&
                            getFieldError<IInfant>(
                              formik.errors.infants,
                              index,
                              "passport_no"
                            ) && (
                              <div className="error-label">
                                {getFieldError<IInfant>(
                                  formik.errors.infants,
                                  index,
                                  "passport_no"
                                )}
                              </div>
                            )}
                        </div>
                      ) : (
                        <div className="fields"></div>
                      )}
                      {isPNRequired ? (
                        <div className="fields">
                          <label
                            className={
                              isFormikErrorsArray<IInfant>(
                                formik.errors.infants
                              ) &&
                              isFormikErrorsArray<IInfant>(
                                formik.touched.infants
                              ) &&
                              formik.touched.infants[index]
                                ?.issue_country_code &&
                              getFieldError<IInfant>(
                                formik.errors.infants,
                                index,
                                "issue_country_code"
                              )
                                ? "error-label"
                                : ""
                            }
                          >
                            Issue Country {isPNRequired && <code>*</code>}
                          </label>
                          <select
                            name={`infants[${index}].issue_country_code`}
                            value={
                              formik.values.infants[index].issue_country_code
                            }
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            className={
                              isFormikErrorsArray<IInfant>(
                                formik.errors.infants
                              ) &&
                              isFormikErrorsArray<IInfant>(
                                formik.touched.infants
                              ) &&
                              formik.touched.infants[index]
                                ?.issue_country_code &&
                              getFieldError<IInfant>(
                                formik.errors.infants,
                                index,
                                "issue_country_code"
                              )
                                ? "error-border py-0"
                                : "py-0"
                            }
                          >
                            <option value="" hidden selected>
                              Select Country
                            </option>
                            {CountryList?.map((e) => (
                              <option
                                key={e?.country_code}
                                value={e?.country_code}
                              >
                                {e?.country_name}
                              </option>
                            ))}
                          </select>
                          {isFormikErrorsArray<IInfant>(
                            formik.errors.infants
                          ) &&
                            isFormikErrorsArray<IInfant>(
                              formik.touched.infants
                            ) &&
                            formik.touched.infants[index]?.issue_country_code &&
                            getFieldError<IInfant>(
                              formik.errors.infants,
                              index,
                              "issue_country_code"
                            ) && (
                              <div className="error-label">
                                {getFieldError<IInfant>(
                                  formik.errors.infants,
                                  index,
                                  "issue_country_code"
                                )}
                              </div>
                            )}
                        </div>
                      ) : (
                        <div className="fields"></div>
                      )}
                    </div>
                    <div className="field-set mb-3">
                      {isPIDRequired ? (
                        <div className="fields">
                          <label
                            className={
                              isFormikErrorsArray<IInfant>(
                                formik.errors.infants
                              ) &&
                              isFormikErrorsArray<IInfant>(
                                formik.touched.infants
                              ) &&
                              formik.touched.infants[index]?.issue_date &&
                              getFieldError<IInfant>(
                                formik.errors.infants,
                                index,
                                "issue_date"
                              )
                                ? "error-label"
                                : ""
                            }
                          >
                            Passport Issue Date{" "}
                            {isPIDRequired && <code>*</code>}
                          </label>
                          <input
                            type="date"
                            name={`infants[${index}].issue_date`}
                            onChange={formik.handleChange}
                            max={moment().format("YYYY-MM-DD")}
                            value={formik.values.infants[index].issue_date}
                            className={
                              isFormikErrorsArray<IInfant>(
                                formik.errors.infants
                              ) &&
                              isFormikErrorsArray<IInfant>(
                                formik.touched.infants
                              ) &&
                              formik.touched.infants[index]?.issue_date &&
                              getFieldError<IInfant>(
                                formik.errors.infants,
                                index,
                                "issue_date"
                              )
                                ? "error-border"
                                : ""
                            }
                          />
                          {isFormikErrorsArray<IInfant>(
                            formik.errors.infants
                          ) &&
                            isFormikErrorsArray<IInfant>(
                              formik.touched.infants
                            ) &&
                            formik.touched.infants[index]?.issue_date &&
                            getFieldError<IInfant>(
                              formik.errors.infants,
                              index,
                              "issue_date"
                            ) && (
                              <div className="error-label">
                                {getFieldError<IInfant>(
                                  formik.errors.infants,
                                  index,
                                  "issue_date"
                                )}
                              </div>
                            )}
                        </div>
                      ) : (
                        <div className="fields"></div>
                      )}
                      {isPPEDRequired ? (
                        <div className="fields">
                          <label
                            className={
                              isFormikErrorsArray<IInfant>(
                                formik.errors.infants
                              ) &&
                              isFormikErrorsArray<IInfant>(
                                formik.touched.infants
                              ) &&
                              formik.touched.infants[index]?.expire_date &&
                              getFieldError<IInfant>(
                                formik.errors.infants,
                                index,
                                "expire_date"
                              )
                                ? "error-label"
                                : ""
                            }
                          >
                            Passport Expiry Date{" "}
                            {isPPEDRequired && <code>*</code>}
                          </label>
                          <input
                            type="date"
                            name={`infants[${index}].expire_date`}
                            onChange={formik.handleChange}
                            min={moment().add(6, "months").format("YYYY-MM-DD")}
                            value={formik.values.infants[index].expire_date}
                            className={
                              isFormikErrorsArray<IInfant>(
                                formik.errors.infants
                              ) &&
                              isFormikErrorsArray<IInfant>(
                                formik.touched.infants
                              ) &&
                              formik.touched.infants[index]?.expire_date &&
                              getFieldError<IInfant>(
                                formik.errors.infants,
                                index,
                                "expire_date"
                              )
                                ? "error-border"
                                : ""
                            }
                          />
                          {isFormikErrorsArray<IInfant>(
                            formik.errors.infants
                          ) &&
                            isFormikErrorsArray<IInfant>(
                              formik.touched.infants
                            ) &&
                            formik.touched.infants[index]?.expire_date &&
                            getFieldError<IInfant>(
                              formik.errors.infants,
                              index,
                              "expire_date"
                            ) && (
                              <div className="error-label">
                                {getFieldError<IInfant>(
                                  formik.errors.infants,
                                  index,
                                  "expire_date"
                                )}
                              </div>
                            )}
                        </div>
                      ) : (
                        <div className="fields"></div>
                      )}
                      <div className="fields"></div>
                    </div>
                  </div>
                )}
              </div>
            ))}
            <a
              className="add-more"
              href="javascript:void(0)"
              onClick={() => {
                if (
                  INFANT > getSelectedItems(formik?.values?.infants)?.length
                ) {
                  push({
                    isSelected: true,
                    first_name: "",
                    last_name: "",
                    // gender: "",
                    initial: "",
                    date_of_birth: "",
                  });
                } else {
                  formik.setFieldError(
                    "infantsLimit",
                    `You have already selected ${INFANT} INFANT. Remove before adding a new one.`
                  );
                }
              }}
            >
              + Add New Infant
            </a>
          </>
        )}
      </FieldArray>
    </div>
  );
};

export default InfantForm;
